<template>
  <div class="menu-items-select-field">
    <v-select
      :value="value"
      :items="filteredItems"
      attach
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      multiple
      outlined
      item-text="name"
      item-value="id"
      :loading="loading"
      :disabled="loading"
      @input="syncValue"
    >
      <template v-slot:prepend-item>
        <v-list-item class="menu-items-select_search">
          <v-list-item-content>
            <v-text-field
              v-model="search"
              label="Поиск..."
              dense
              clearable
            >
              <template v-slot:append>
                <font-awesome-icon color="#ccc" icon="search" />
              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    name: 'MenuItemsSelectFields',
    components: { },
    mixins: [rules],
    data () {
      return {
        search: '',
      }
    },
    props: {
      label: {
        type: String,
        default: 'Блюда',
      },
      value: {
        type: Array,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        menuItems: 'menuItems/getMenuItemsList',
      }),
      showEmptyText () {
        return this.emptyText && _.isEmpty(this.value) && !this.loading
      },
      hint () {
        return this.showEmptyText ? this.emptyText : null
      },
      filteredItems () {
        if (!this.search) {
          return this.menuItems
        }
        return this.menuItems.filter((item) => {
          return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },
    },
    methods: {
      syncValue (value) {
        this.search = ''
        this.$emit('input', value)
      },
    },
    created () {
      if (!this.menuItems || this.menuItems.length === 0) {
        this.$store.dispatch('menuItems/fetchMenuItemsList')
      }
    },
  }
</script>

<style lang="less" scoped>
.menu-items-select-field {
  ::v-deep {
    .v-text-field .v-label--active {
      transform: translateY(-25px) scale(0.75);
    }
  }

  .menu-items-select_search {
    margin-top: -5px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;

    ::v-deep {
      .v-list-item__content {
        padding-bottom: 0;
      }
    }
  }
}
</style>
